import { FlexDiv } from '@/app/shared/common.StyledComponents';
import { useShowDebtorPortalComponents } from '@/app/shared/hooks/useShowDebtorPortalComponents';
import { ExternalRoutes } from '@/app/shared/routes';
import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';
import { Trans, useTranslation } from 'react-i18next';
import { LayoutFooterLink } from '../../PublicLayout/components/LayoutFooterLink';
import { PageRoutes } from '@/app/components/router/routes';
import { TriumphContactUrl } from '@/app/shared/constants/companies/utils';

const FooterWrapper = styled.div`
  width: 100%;
  background: ${({ theme }: any) => theme.colors.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }: any) => theme.colors.greyscale.white};
  padding: ${rem(12)} ${rem(16)};
  line-height: ${rem(20)};
  text-align: center;

  a:link {
    color: white;
  }

  a:visited {
    color: white;
  }
`;

const DashboardFooterWrapper = styled.div`
  width: 100%;
  background: ${({ theme }: any) => theme.colors.background};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${rem(46)};
  color: ${({ theme }: any) => theme.colors.greyscale.white};
  padding: ${rem(24)} ${rem(100)};
  line-height: ${rem(20)};

  a:link {
    color: white;
  }

  a:visited {
    color: white;
  }
`;

const RightSideContainer = styled(FlexDiv)`
  align-items: center;
  margin-left: auto;
`;

export const GlobalFooter = () => {
  const { t } = useTranslation('footer');
  const showDebtorPortalComponents = useShowDebtorPortalComponents();

  return showDebtorPortalComponents ? (
    <DashboardFooterWrapper>
      <u>
        <LayoutFooterLink href={TriumphContactUrl} linkText="contactUs" />
      </u>
      <u>
        <LayoutFooterLink href={PageRoutes.TERMS} linkText="termsOfUse" />
      </u>
      <u>
        <LayoutFooterLink
          href={ExternalRoutes.TbkPrivacyPolicy}
          linkText="privacyPolicy"
        />
      </u>
      <RightSideContainer>{t('tbc')}</RightSideContainer>
    </DashboardFooterWrapper>
  ) : (
    <FooterWrapper>
      <a href={ExternalRoutes.TbkPrivacyPolicy}>{t('privacyPolicy')}</a>
      <span>
        <Trans ns="footer" i18nKey="footerText" components={{ 1: <br /> }} />
      </span>
    </FooterWrapper>
  );
};
